/**
 * A FAIXA DE MÉTRICAS (spec 23, terceira rodada): ícone num ladrilho de cor suave, o número grande e uma linha curta.
 *
 * Pedido do owner (01/11): *"intuitivo, visualmente interessante, usando ícones, cores, pouco texto, minimalista
 * estilo escandinavo"*. O `PainelDeIndicadores` do kit é texto sobre texto (rótulo, número, frase); aqui o ícone diz
 * do que é o número antes da leitura, e a frase de baixo é uma só, curta, com `title` para o resto.
 *
 * Um tom de ALERTA (`alerta`) pinta o número e o ladrilho de âmbar/vermelho: é o que pede ação. Só ele chama — realçar
 * todos seria não realçar nenhum.
 */
import type { ReactNode } from "react";
import type { TomDoLadrilho } from "./linguagem.js";

export interface Metrica {
  readonly id: string;
  readonly icone: ReactNode;
  readonly tom: TomDoLadrilho;
  readonly rotulo: string;
  readonly valor: ReactNode | null;
  /** Uma linha, curta. O texto inteiro vai no `title`. */
  readonly detalhe?: ReactNode;
  readonly dica?: string;
  readonly alerta?: "atencao" | "perigo";
  /** Navegação de documento (outro build, como `/atender`). */
  readonly href?: string;
  readonly aoAbrir?: () => void;
}

export function Metricas(props: { readonly rotulo: string; readonly itens: readonly Metrica[] }) {
  return (
    <ul className="hugi-metricas" aria-label={props.rotulo}>
      {props.itens.map((m) => {
        const miolo = (
          <>
            {/* Ícone e número na mesma linha, a palavra inteira embaixo: ao lado do ícone, "Em atendimento" cortava, e
                empilhados os três o cartão ficava alto demais (owner, 01/11: "cards grandes"). */}
            <span className="hugi-metrica-topo">
              <span aria-hidden="true" className={`ladrilho ${m.alerta ? `alerta-${m.alerta}` : m.tom}`}>{m.icone}</span>
              <strong className={m.valor === null ? "is-ausente" : undefined}>{m.valor ?? "—"}</strong>
            </span>
            <span className="hugi-metrica-rotulo">{m.rotulo}</span>
            {m.detalhe !== undefined ? <span className="hugi-metrica-detalhe">{m.detalhe}</span> : null}
          </>
        );
        const classe = `hugi-metrica${m.alerta ? ` is-${m.alerta}` : ""}`;
        return (
          <li key={m.id} className={classe} {...(m.dica ? { title: m.dica } : {})}>
            {m.href ? (
              <a href={m.href}>{miolo}</a>
            ) : m.aoAbrir ? (
              <button type="button" onClick={m.aoAbrir}>
                {miolo}
              </button>
            ) : (
              <div>{miolo}</div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
